import React, { useState } from 'react';
import CustomNumberInput from '@/components/ui/general/custom-number-input/CustomNumberInput';

// ¡No necesitas importar 'feedback' aquí, el hook se encargará!
// import feedback from './feedback/feedback';

function CreateGameForm({ selectedPlayer, onCreateGame, error, isLoading }) {
  
  // ✅ Nuevos nombres espaciales
  const nameParts1 = ['Nebula', 'Orion', 'Andromeda', 'Cygnus', 'Centauri', 'Sirius', 'Vega'];
  const nameParts2 = ['Expanse', 'Void', 'Cluster', 'Reach', 'Sector', 'Anomaly', 'Drift'];
  const emojis = ['🪐', '✨', '☄️', '💫', '🌌', '🚀'];

  const generateRandomName = () => {
    const part1 = nameParts1[Math.floor(Math.random() * nameParts1.length)];
    const part2 = nameParts2[Math.floor(Math.random() * nameParts2.length)];
    const emoji = emojis[Math.floor(Math.random() * emojis.length)];
    const num = Math.floor(100 + Math.random() * 900);
    return `${emoji} ${part1} ${part2} ${num}`;
  };
  //Genera el codigo de un juego nuevo
  const generateGameCode = () => {
    return Math.random().toString(36).substr(2, 6).toUpperCase(); 
  };

  const [gameName, setGameName] = useState(generateRandomName());
  const [mapWidth, setMapWidth] = useState(20);
  const [mapHeight, setMapHeight] = useState(20);
  const [isPublic, setIsPublic] = useState(true); 
  const [password, setPassword] = useState('');  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedPlayer) {
      return;
    }
    onCreateGame({
      player_id: selectedPlayer,
      name: gameName || null,
      map_width: parseInt(mapWidth, 10),
      map_height: parseInt(mapHeight, 10),
      max_players: 2,
      visibility: isPublic ? 'public' : 'private',
      access_code: isPublic ? null : password
    });
    
  };

  return (
    <form onSubmit={handleSubmit} className="create-game-form">
      <h4>Crear Nuevo Juego (1 vs AI)</h4>
      {error && <p className="error-message">{error}</p>}

      <div className="form-row">
        <div className="form-group form-group-large">
          <label htmlFor="gameName">Game name:</label>
          <input
            id="gameName"
            type="text"
            value={gameName}
            onChange={(e) => setGameName(e.target.value)}
            placeholder="Nombre de la partida..."
          />
        </div>
        
        <CustomNumberInput 
          label="Ancho del Mapa"
          value={mapWidth}
          onChange={(e) => setMapWidth(e.target.value)}
          min="10"
          max="50"
        />
        
        <CustomNumberInput 
          label="Alto del Mapa"
          value={mapHeight}
          onChange={(e) => setMapHeight(e.target.value)}
          min="10"
          max="50"
        />

        {/* Selector del tipo de partida pública / privada */}
        <div className="form-group switch-group">
          <label className="switch">
          <input
            type="checkbox"
            checked={isPublic}
            onChange={() => {
              const next = !isPublic;
              setIsPublic(next);
              if (!next) {
                setPassword(generateGameCode()); // Genera clave automática
              } else {
                setPassword(''); // Limpia clave si vuelve a pública
              }
            }}
          />
            <span className="slider">
              <span className="pill">{isPublic ? "Pública" : "Privada"}</span>
            </span>
          </label>
        </div>
        {!isPublic && (
        <div className="form-group">
          <label htmlFor="password">Clave de la partida:</label>
          <input
            id="password"
            type="text"
            value={password}
            readOnly
          />
        </div>
)}


      </div>
      
      <button type="submit" disabled={!selectedPlayer || isLoading} className="form-submit-button cta">
        {isLoading ? 'Creating...' : 'Create Game'}
      </button>

      {!selectedPlayer && <p className="warning-message">Selecciona un jugador para poder crear un Juego.</p>}
    </form>
  );
}

export default CreateGameForm;